'use-client';
import * as React from 'react';
import {
  ArtistName,
  TrackName,
  PlayPause,
  ProgressBar,
  TimeStamp,
} from '@wix/soundhead-react';
import classnames from 'clsx';
import type {
  ISingleAudioPlayerProps,
  IPlayerProps,
} from '../../../SingleAudioPlayer.types';
import VolumeControls from '../../components/VolumeControls/VolumeControls';
import PlayerContainer from '../../components/PlayerContainer/PlayerContainer';
import { TestHooks } from '../../constants';
import style from '../../style/SingleAudioPlayerSkin.scss';

const Player: React.FC<IPlayerProps> = props => {
  const {
    id,
    className,
    isMute,
    shouldDisplayRepeatIcon,
    onMouseEnter,
    onMouseLeave,
    ariaLabel,
  } = props;
  return (
    <div
      id={id}
      className={classnames(className, style.SingleAudioPlayerSkin)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="application"
      aria-label={ariaLabel}
    >
      <div className={style.player}>
        <div className={style.info}>
          <TrackName className={style.trackLabel} />
          <span className={style.separator}>{' - '}</span>
          <ArtistName className={style.artistLabel} />
        </div>
        <div className={style.mediaControls}>
          <div
            className={style.mediaButtonContainer}
            data-testid={TestHooks.play}
          >
            <PlayPause
              className={classnames(style.mediaButton, {
                [style.repeat]: shouldDisplayRepeatIcon,
              })}
              iconPlay={
                <span
                  className={classnames(style.mediaButtonIcon, style.play)}
                  data-testid={TestHooks.playIcon}
                />
              }
              iconPause={
                <span
                  className={classnames(style.mediaButtonIcon, style.pause)}
                  data-testid={TestHooks.pauseIcon}
                />
              }
            />
          </div>
          <ProgressBar className={style.progressbar} />
          <VolumeControls className={style.volumeControls} isMute={isMute} />
          <div className={style.timeStampsContainer}>
            <TimeStamp
              display="currentTime"
              className={classnames(style.duration, style.trackPosition)}
            />
            <span className={style.separator2}>{' / '}</span>
            <TimeStamp
              display="duration"
              className={classnames(style.duration, style.trackDuration)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const SingleAudioPlayerSkin: React.FC<ISingleAudioPlayerProps> = props => {
  return <PlayerContainer {...props} player={Player} />;
};

export default SingleAudioPlayerSkin;
